import { render, staticRenderFns } from "./remove-group.vue?vue&type=template&id=738bb496"
import script from "./remove-group.vue?vue&type=script&lang=js"
export * from "./remove-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('738bb496')) {
      api.createRecord('738bb496', component.options)
    } else {
      api.reload('738bb496', component.options)
    }
    module.hot.accept("./remove-group.vue?vue&type=template&id=738bb496", function () {
      api.rerender('738bb496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/group/remove-group.vue"
export default component.exports